import gql from 'graphql-tag'

export const barcodeSheetQuery = gql`
  query BarcodeSheet($accountId: Int!) {
    barcodeSheet(accountId: $accountId) {
      id
      accountId
      name
      size
      width
      height
      topMargin
      bottomMargin
      leftMargin
      rightMargin
      rows
      columns
      rowGutter
      columnGutter
      unit
      labels(accountId: $accountId) {
        id
        accountId
        barcodeSheetId
        name
        width
        height
        elements
      }
    }
  }
`
